import { Heading } from '@cinch-labs/design-system'
import {
  FeatureCardRichText,
  FeatureCardRichTextProps,
} from '../feature-card-rich-text'
import styles from './feature-card-row-wrapper.module.css'

interface Row {
  columns: FeatureCardRichTextProps[]
}

interface GridRowsProps {
  rows: Row[]
}

export interface FeatureCardRowWrapperProps {
  title: string
  content: GridRowsProps[]
}

export const FeatureCardRowWrapper = ({
  title,
  content,
}: FeatureCardRowWrapperProps) => {
  const cards = content[0]?.rows[0]?.columns ?? []

  return (
    <div className={styles.container}>
      <div className={styles.heading}>
        <Heading element="h2" className={styles.title}>
          {title}
        </Heading>
      </div>
      <div
        className={styles.cardsContainer}
        aria-label="feature card container"
      >
        {cards?.map((card: FeatureCardRichTextProps) => (
          <FeatureCardRichText {...card} key={card.title} />
        ))}
      </div>
    </div>
  )
}
